export default {
  MY_INVESTMENT_EMAIL_STATE_MANAGER: Symbol.for('MY_INVESTMENT_EMAIL_STATE_MANAGER'),
  SEARCH_MY_INVESTMENT_EMAIL_REPOSITORY: Symbol.for('SEARCH_MY_INVESTMENT_EMAIL_REPOSITORY'),
  SEARCH_MY_INVESTMENT_EMAILS_QUERY: Symbol.for('SEARCH_MY_INVESTMENT_EMAILS_QUERY'),
};
